module.exports = __webpack_public_path__ + "img/smallTruck-blue.fac01547.svg";